// ENG-4037 popped picker sort (spec §6.3, prototype `studioSort`):
// this-device studios first, then active studios (deviceCount > 0), then
// online before offline, with a stable name tiebreak so renders never shuffle.
import type { StudioPickerDescriptor } from '../types.js';

/** Comparator for popped picker cards. Pure — unit-tested directly. */
export const studioSort = (a: StudioPickerDescriptor, b: StudioPickerDescriptor): number => {
  // Priority 1: the studio hosting THIS device.
  if (a.isThisDevice !== b.isThisDevice) {
    return a.isThisDevice ? -1 : 1;
  }

  // Priority 2: active studios (have at least one device) before empty ones.
  const aActive = a.deviceCount > 0;
  const bActive = b.deviceCount > 0;

  if (aActive !== bActive) {
    return aActive ? -1 : 1;
  }

  // Priority 3: online before offline.
  if (a.status !== b.status) {
    return a.status === 'online' ? -1 : 1;
  }

  // Stable tiebreak: alphabetical by studio name.
  return a.room.name.localeCompare(b.room.name, undefined, { sensitivity: 'base' });
};

/** Non-mutating sorted copy. */
export const sortStudios = (
  descriptors: readonly StudioPickerDescriptor[]
): StudioPickerDescriptor[] => [...descriptors].sort(studioSort);
